import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28952906"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "buttons-container"
}
const _hoisted_2 = {
  key: 1,
  class: "buttons-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ActiveCall = _resolveComponent("ActiveCall")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isMaximize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Button, {
            class: "button",
            iconOnly: "",
            size: "l",
            disabled: _ctx.isCallPaused || _ctx.isCallProgressing,
            icon: {name: _ctx.settings.mute ? 'ic24-mic-off' : 'ic24-mic', color: _ctx.getIconColor(_ctx.isCallPaused || _ctx.isCallProgressing, false)},
            mode: "outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.changeMute(!_ctx.settings.mute);})
          }, null, 8, ["disabled", "icon"]),
          _createVNode(_component_Button, {
            class: "button",
            disabled: _ctx.isCallPaused || _ctx.settings.sharing || _ctx.isCallProgressing,
            size: "l",
            icon: { spriteUrl: 'static/icons-pack.svg', name: _ctx.settings.videoMute && !_ctx.isCallProgressing ? 'ic24-videocamera-off' : 'ic24-videocamera', color: _ctx.getIconColor(_ctx.settings.sharing || _ctx.isCallProgressing, true) },
            mode: "outlined",
            iconOnly: "",
            onClick: _ctx.toggleVideo
          }, null, 8, ["disabled", "icon", "onClick"]),
          (_ctx.selectCall)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "button",
                mode: "outlined",
                iconOnly: "",
                size: "l",
                disabled: !_ctx.canCurrentCallToggleActive || _ctx.isCallProgressing,
                icon: _ctx.selectCall.active ? 'ic24-pause' : 'ic24-play',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.canCurrentCallToggleActive && _ctx.toggleCallStatus()))
              }, null, 8, ["disabled", "icon"]))
            : _createCommentVNode("", true),
          (_ctx.selectCall)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "fullscreen button",
                mode: "outlined",
                disabled: _ctx.isCallPaused || _ctx.isCallProgressing || _ctx.settings.remoteSharing,
                iconOnly: "",
                size: "l",
                icon: { spriteUrl: 'static/icons-pack.svg', name: _ctx.settings.sharing ? 'ic24-sharing-stop' : 'ic24-sharing'},
                onClick: _ctx.toggleSharing
              }, null, 8, ["disabled", "icon", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "button",
            iconOnly: "",
            size: "l",
            disabled: _ctx.isCallProgressing,
            icon: {name: 'ic20-numbers', width: '20px', height: '20px'},
            mode: "outlined",
            onClick: _cache[2] || (_cache[2] = () => { _ctx.changeComponent('Dialing'); _ctx.changeComponentDialingStatus('toneDial') })
          }, null, 8, ["disabled"]),
          _createVNode(_component_Button, {
            class: "button",
            iconOnly: "",
            size: "l",
            disabled: _ctx.isCallProgressing,
            icon: { spriteUrl: 'static/icons-pack.svg', name: 'ic24-phone-new' },
            mode: "outlined",
            onClick: _ctx.makeNewCall
          }, null, 8, ["disabled", "icon", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMaximize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "button button-big",
            icon: {name: 'ic20-phone-missed', color: '--sui-white'},
            mode: "alert",
            onClick: _cache[3] || (_cache[3] = () => _ctx.hangUp({ id: _ctx.selectCall.id }))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttons.end')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isMaximize && _ctx.showFooter)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["buttons-maximize-container", {'container-absolute': _ctx.settings.fullscreen}])
            }, [
              _createVNode(_component_ActiveCall, { class: "video-active-call" }),
              _createElementVNode("div", {
                class: _normalizeClass(["buttons", {'full-screen': _ctx.settings.fullscreen}])
              }, [
                _createVNode(_component_Button, {
                  iconOnly: "",
                  size: "l",
                  icon: {name: _ctx.settings.mute ? 'ic24-mic-off' : 'ic24-mic', color: _ctx.settings.mute ? '--sui-red-500' : _ctx.getMuteIconColor},
                  disabled: _ctx.isCallPaused || _ctx.isCallProgressing,
                  class: _normalizeClass(_ctx.getAudioBtnClasses),
                  mode: !_ctx.settings.fullscreen && 'outlined',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.changeMute(!_ctx.settings.mute);})
                }, null, 8, ["icon", "disabled", "class", "mode"]),
                _createVNode(_component_Button, {
                  iconOnly: "",
                  size: "l",
                  disabled: _ctx.isCallPaused || _ctx.settings.sharing || _ctx.isCallProgressing,
                  icon: { spriteUrl: 'static/icons-pack.svg', name: _ctx.settings.videoMute ? 'ic24-videocamera-off' : 'ic24-videocamera' },
                  class: _normalizeClass(_ctx.getVideoBtnClasses),
                  mode: !_ctx.settings.fullscreen && 'outlined',
                  onClick: _ctx.toggleVideo
                }, null, 8, ["disabled", "icon", "class", "mode", "onClick"]),
                (_ctx.selectCall)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: _normalizeClass({..._ctx.getFullscreenBtnClasses, 'fullscreen-disabled': !_ctx.canCurrentCallToggleActive || _ctx.isCallProgressing}),
                      mode: !_ctx.settings.fullscreen && 'outlined',
                      iconOnly: "",
                      size: "l",
                      disabled: !_ctx.canCurrentCallToggleActive || _ctx.isCallProgressing,
                      icon: _ctx.selectCall.active ? 'ic24-pause' : 'ic24-play',
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.canCurrentCallToggleActive && _ctx.toggleCallStatus()))
                    }, null, 8, ["class", "mode", "disabled", "icon"]))
                  : _createCommentVNode("", true),
                (_ctx.selectCall)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: _normalizeClass({..._ctx.getFullscreenBtnClasses, 'fullscreen-disabled': _ctx.isCallProgressing}),
                      mode: !_ctx.settings.fullscreen && 'outlined',
                      iconOnly: "",
                      size: "l",
                      disabled: _ctx.isCallPaused || _ctx.isCallProgressing || _ctx.settings.remoteSharing,
                      icon: { spriteUrl: 'static/icons-pack.svg', name: _ctx.settings.sharing ? 'ic24-sharing-stop' : 'ic24-sharing'},
                      onClick: _ctx.toggleSharing
                    }, null, 8, ["class", "mode", "disabled", "icon", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  iconOnly: "",
                  size: "l",
                  disabled: _ctx.isCallProgressing,
                  icon: {name: 'ic20-numbers', width: '20px', height: '20px'},
                  class: _normalizeClass(_ctx.getFullscreenBtnClasses),
                  mode: !_ctx.settings.fullscreen && 'outlined',
                  onClick: _cache[6] || (_cache[6] = () => { _ctx.changeComponent('Dialing'); _ctx.changeComponentDialingStatus('toneDial') })
                }, null, 8, ["disabled", "class", "mode"]),
                _createVNode(_component_Button, {
                  iconOnly: "",
                  size: "l",
                  disabled: _ctx.isCallProgressing,
                  icon: { spriteUrl: 'static/icons-pack.svg', name: 'ic24-phone-new' },
                  class: _normalizeClass(_ctx.getFullscreenBtnClasses),
                  mode: !_ctx.settings.fullscreen && 'outlined',
                  onClick: _ctx.makeNewCall
                }, null, 8, ["disabled", "icon", "class", "mode", "onClick"]),
                (_ctx.selectCall && !_ctx.settings.fullscreen)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: _normalizeClass(_ctx.getFullscreenBtnClasses),
                      mode: !_ctx.settings.fullscreen && 'outlined',
                      iconOnly: "",
                      size: "l",
                      disabled: _ctx.isCallProgressing,
                      icon: {name: 'ic24-fullscreen'},
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleFullScreen(true)))
                    }, null, 8, ["class", "mode", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.selectCall && _ctx.settings.fullscreen)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 3,
                      class: _normalizeClass(_ctx.getFullscreenBtnClasses),
                      mode: !_ctx.settings.fullscreen && 'outlined',
                      iconOnly: "",
                      size: "l",
                      disabled: _ctx.isCallProgressing,
                      icon: {name: 'ic24-fullscreen-exit'},
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleFullScreen(false)))
                    }, null, 8, ["class", "mode", "disabled"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  class: "button button-big",
                  size: "l",
                  icon: {name: 'ic24-close', color: '--sui-white'},
                  mode: "alert",
                  onClick: _cache[9] || (_cache[9] = () => _ctx.hangUp({ id: _ctx.selectCall.id }))
                })
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}